<template>
  
<div>

<footer class="pt-4 my-md-5 pt-md-5 border-top border-bottom background-white float-bottom navbar-fixed-bottom">
  <div class="container">
  <div class="row">
      <div class="col-12 col-md d-block d-md-none text-center">
          <img class="mb-2" src="" alt="" width="126" height="60" >
          <small><p class="d-block mb-3 text-muted">&copy; 2020 - Packtracker</p></small>
         <small><router-link v-if="isLoggedIn == false" class="d-block mb-3 text-muted" :to="{ name: 'login'}">Login</router-link></small> 
         <small><a class="d-block mb-3 text-muted" v-if="isLoggedIn == true" @click="logout">Log out</a></small>
      </div>

      <div class="col-2 col-md d-none d-md-block">
          <img class="mb-2" src="" alt="" width="126" height="60" >
          <small><p class="d-block mb-3 text-muted">&copy; 2020 - Packtracker</p></small>
         <small><router-link v-if="isLoggedIn == false" class="d-block mb-3 text-muted" :to="{ name: 'login'}">Login</router-link></small> 
         <small><a class="d-block mb-3 text-muted" v-if="isLoggedIn == true" @click="logout">Log out</a></small>
      </div>

      <div class="col-2 col-md d-none d-md-block">
        <h5>Packtracker</h5>
        <ul class="list-unstyled text-small">
          <li><a class="text-muted" href="#">About</a></li>
          <li><a class="text-muted" href="#">Features</a></li>
          <li><a class="text-muted" href="#">Pricing</a></li>
          <li><a class="text-muted" href="#">Integrations</a></li>
  
        </ul>
      </div>

      <div class="col-2 col-md d-none d-md-block">
          <h5>Help and support</h5>
          <ul class="list-unstyled text-small">
          <li><a class="text-muted" href="#">Get started</a></li>
          <li><a class="text-muted" href="#">FAQ</a></li>
          <li><a class="text-muted" href="#">Developer</a></li>
          <li><a class="text-muted" href="#">Contact us</a></li>

          </ul>
      </div>

      <div class="col-6 col-md d-none d-md-block">

          <b-dropdown :text="$t('text1.language')" variant="outline-primary" class="mb-12">
                 <b-dropdown-item v-on:click="changeLanguageEN">English </b-dropdown-item>
                <b-dropdown-item v-on:click="changeLanguageCN">Chinese (中文)</b-dropdown-item>
                <b-dropdown-item v-on:click="changeLanguageNO">Norsk</b-dropdown-item>
                <b-dropdown-item v-on:click="changeLanguageFR">Français</b-dropdown-item>
                <b-dropdown-item v-on:click="changeLanguageIS">Íslensku</b-dropdown-item>
                <b-dropdown-item v-on:click="changeLanguageJP">Japanese (日本人)</b-dropdown-item>
                <b-dropdown-item v-on:click="changeLanguagePL">Polskie</b-dropdown-item>
          </b-dropdown>


          <!-- <div class="form-group col-md-12">
             
                <select class="form-control" v-model="settings.market">
                  <option value="NO">Norway</option>
                  <option value="UK">United Kingdom</option>
                  <option value="HU">Hungary</option>
                  <option value="AD">Andorra</option>
                  <option value="AE">United Arab Emirates</option>
                  <option value="AF">Afghanistan</option>
                  <option value="AG">Antigua and Barbuda</option>
                  <option value="AI">Anguilla</option>
                  <option value="AL">Albania</option>
                  <option value="AM">Armenia</option>
                  <option value="AO">Angola</option>
                  <option value="AQ">Antarctica</option>
                  <option value="AR">Argentina</option>
                  <option value="AS">American Samoa</option>
                  <option value="AT">Austria</option>
                  <option value="AU">Australia</option>
                  <option value="AW">Aruba</option>
                  <option value="AZ">Azerbaijan</option>
                  <option value="BA">Bosnia and Herzegovina</option>
                  <option value="BB">Barbados</option>
                  <option value="BD">Bangladesh</option>
                  <option value="BE">Belgium</option>
                  <option value="BF">Burkina Faso</option>
                  <option value="BG">Bulgaria</option>
                  <option value="BH">Bahrain</option>
                  <option value="BI">Burundi</option>
                  <option value="BJ">Benin</option>
                  <option value="BL">Saint Barthelemy</option>
                  <option value="BM">Bermuda</option>
                  <option value="BN">Brunei</option>
                  <option value="BO">Bolivia</option>
                  <option value="BQ">Caribbean Netherlands</option>
                  <option value="BR">Brazil</option>
                  <option value="BS">Bahamas</option>
                  <option value="BT">Bhutan</option>
                  <option value="BW">Botswana</option>
                  <option value="BY">Belarus</option>
                  <option value="BZ">Belize</option>
                  <option value="CA">Canada</option>
                  <option value="CC">Cocos (Keeling) Islands</option>
                  <option value="CD">DR Congo</option>
                  <option value="CF">Central African Republic</option>
                  <option value="CG">Congo</option>
                  <option value="CH">Switzerland</option>
                  <option value="CI">Ivory Coast</option>
                  <option value="CK">Cook Islands</option>
                  <option value="CL">Chile</option>
                  <option value="CM">Cameroon</option>
                  <option value="CN">China</option>
                  <option value="CO">Colombia</option>
                  <option value="CR">Costa Rica</option>
                  <option value="CU">Cuba</option>
                  <option value="CV">Cape Verde</option>
                  <option value="CW">Curacao</option>
                  <option value="CX">Christmas Island</option>
                  <option value="CY">Cyprus</option>
                  <option value="CZ">Czech Republic</option>
                  <option value="DE">Germany</option>
                  <option value="DJ">Djibouti</option>
                  <option value="DK">Denmark</option>
                  <option value="DM">Dominica</option>
                  <option value="DO">Dominican Republic</option>
                  <option value="DZ">Algeria</option>
                  <option value="EC">Ecuador</option>
                  <option value="EE">Estonia</option>
                  <option value="EG">Egypt</option>
                  <option value="ER">Eritrea</option>
                  <option value="ES">Spain</option>
                  <option value="ET">Ethiopia</option>
                  <option value="FI">Finland</option>
                  <option value="FJ">Fiji</option>
                  <option value="FK">Falkland Islands</option>
                  <option value="FM">Micronesia</option>
                  <option value="FO">Faroe Islands</option>
                  <option value="FR">France</option>
                  <option value="GA">Gabon</option>
                  <option value="GD">Grenada</option>
                  <option value="GE">Georgia</option>
                  <option value="GF">French Guiana</option>
                  <option value="GG">Guernsey</option>
                  <option value="GH">Ghana</option>
                  <option value="GI">Gibraltar</option>
                  <option value="GL">Greenland</option>
                  <option value="GM">Gambia</option>
                  <option value="GN">Guinea</option>
                  <option value="GP">Guadeloupe</option>
                  <option value="GQ">Equatorial Guinea</option>
                  <option value="GR">Greece</option>
                  <option value="GS">South Georgia & South Sandwich Islands</option>
                  <option value="GT">Guatemala</option>
                  <option value="GU">Guam</option>
                  <option value="GW">Guinea-Bissau</option>
                  <option value="GY">Guyana</option>
                  <option value="HK">Hong Kong</option>
                  <option value="HN">Honduras</option>
                  <option value="HR">Croatia</option>
                  <option value="HT">Haiti</option>
                  <option value="HU">Hungary</option>
                  <option value="ID">Indonesia</option>
                  <option value="IE">Ireland</option>
                  <option value="IL">Israel</option>
                  <option value="IN">India</option>
                  <option value="IQ">Iraq</option>
                </select>
            </div>
      
            <div class="form-group col-md-12">
           
                <select class="form-control" v-model="settings.locale">
                  <option value="nb-NO">norsk, bokmål (Norge)</option>
                  <option value="ar-AE">العربية (الإمارات العربية المتحدة)</option>
                  <option value="az-AZ">Azərbaycan\u00adılı (Azərbaycan)</option>
                  <option value="bg-BG">български (България)</option>
                  <option value="ca-ES">català (català)</option>
                  <option value="cs-CZ">čeština (Česká republika)</option>
                  <option value="da-DK">dansk (Danmark)</option>
                  <option value="de-DE">Deutsch (Deutschland)</option>
                  <option value="el-GR">Ελληνικά (Ελλάδα)</option>
                  <option value="en-GB">English (United Kingdom)</option>
                  <option value="en-US">English (United States)</option>
                  <option value="es-ES">Español (España)</option>
                  <option value="es-MX">Español (México)</option>
                  <option value="et-EE">eesti (Eesti)</option>
                  <option value="fi-FI">suomi (Suomi)</option>
                  <option value="fr-FR">français (France)</option>
                  <option value="hr-HR">hrvatski (Hrvatska)</option>
                  <option value="hu-HU">magyar (Magyarország)</option>
                  <option value="id-ID">Bahasa Indonesia (Indonesia)</option>
                  <option value="it-IT">italiano (Italia)</option>
                  <option value="ja-JP">日本語 (日本)</option>
                  <option value="ko-KR">한국어 (대한민국)</option>
                  <option value="lt-LT">lietuvių (Lietuva)</option>
                  <option value="lv-LV">latviešu (Latvija)</option>
                  <option value="ms-MY">Bahasa Melayu (Malaysia)</option>
                  <option value="nl-NL">Nederlands (Nederland)</option>
                  <option value="pl-PL">polski (Polska)</option>
                  <option value="pt-BR">Português (Brasil)</option>
                  <option value="pt-PT">português (Portugal)</option>
                  <option value="ro-RO">română (România)</option>
                  <option value="ru-RU">русский (Россия)</option>
                  <option value="sk-SK">slovenčina (Slovenská republika)</option>
                  <option value="sv-SE">svenska (Sverige)</option>
                  <option value="th-TH">ไทย (ไทย)"</option>
                  <option value="tl-PH">Filipino (Pilipinas)</option>
                  <option value="tr-TR">Türkçe (Türkiye)</option>
                  <option value="uk-UA">українська (Україна)</option>
                  <option value="vi-VN">Tiếng Việt (Việt Nam)</option>
                  <option value="zh-CN">简体中文</option>
                  <option value="zh-HK">繁體中文</option>
                  <option value="zh-SG">中文(新加坡)</option>
                  <option value="zh-TW">繁體中文</option>
                </select>
            </div>
      
            <div class="form-group col-md-12">
              
                <select class="form-control" v-model="settings.currency">
                  <option value="USD" selected="selected">United States Dollars</option>
                  <option value="EUR">Euro</option>
                  <option value="GBP">United Kingdom Pounds</option>
                  <option value="DZD">Algeria Dinars</option>
                  <option value="ARP">Argentina Pesos</option>
                  <option value="AUD">Australia Dollars</option>
                  <option value="ATS">Austria Schillings</option>
                  <option value="BSD">Bahamas Dollars</option>
                  <option value="BBD">Barbados Dollars</option>
                  <option value="BEF">Belgium Francs</option>
                  <option value="BMD">Bermuda Dollars</option>
                  <option value="BRR">Brazil Real</option>
                  <option value="BGL">Bulgaria Lev</option>
                  <option value="CAD">Canada Dollars</option>
                  <option value="CLP">Chile Pesos</option>
                  <option value="CNY">China Yuan Renmimbi</option>
                  <option value="CYP">Cyprus Pounds</option>
                  <option value="CSK">Czech Republic Koruna</option>
                  <option value="DKK">Denmark Kroner</option>
                  <option value="NLG">Dutch Guilders</option>
                  <option value="XCD">Eastern Caribbean Dollars</option>
                  <option value="EGP">Egypt Pounds</option>
                  <option value="FJD">Fiji Dollars</option>
                  <option value="FIM">Finland Markka</option>
                  <option value="FRF">France Francs</option>
                  <option value="DEM">Germany Deutsche Marks</option>
                  <option value="XAU">Gold Ounces</option>
                  <option value="GRD">Greece Drachmas</option>
                  <option value="HKD">Hong Kong Dollars</option>
                  <option value="HUF">Hungary Forint</option>
                  <option value="ISK">Iceland Krona</option>
                  <option value="INR">India Rupees</option>
                  <option value="IDR">Indonesia Rupiah</option>
                  <option value="IEP">Ireland Punt</option>
                  <option value="ILS">Israel New Shekels</option>
                  <option value="ITL">Italy Lira</option>
                  <option value="JMD">Jamaica Dollars</option>
                  <option value="JPY">Japan Yen</option>
                  <option value="JOD">Jordan Dinar</option>
                  <option value="KRW">Korea (South) Won</option>
                  <option value="LBP">Lebanon Pounds</option>
                  <option value="LUF">Luxembourg Francs</option>
                  <option value="MYR">Malaysia Ringgit</option>
                  <option value="MXP">Mexico Pesos</option>
                  <option value="NLG">Netherlands Guilders</option>
                  <option value="NZD">New Zealand Dollars</option>
                  <option value="NOK">Norway Kroner</option>
                  <option value="PKR">Pakistan Rupees</option>
                  <option value="XPD">Palladium Ounces</option>
                  <option value="PHP">Philippines Pesos</option>
                  <option value="XPT">Platinum Ounces</option>
                  <option value="PLZ">Poland Zloty</option>
                  <option value="PTE">Portugal Escudo</option>
                  <option value="ROL">Romania Leu</option>
                  <option value="RUR">Russia Rubles</option>
                  <option value="SAR">Saudi Arabia Riyal</option>
                  <option value="XAG">Silver Ounces</option>
                  <option value="SGD">Singapore Dollars</option>
                  <option value="SKK">Slovakia Koruna</option>
                  <option value="ZAR">South Africa Rand</option>
                  <option value="KRW">South Korea Won</option>
                  <option value="ESP">Spain Pesetas</option>
                  <option value="XDR">Special Drawing Right (IMF)</option>
                  <option value="SDD">Sudan Dinar</option>
                  <option value="SEK">Sweden Krona</option>
                  <option value="CHF">Switzerland Francs</option>
                  <option value="TWD">Taiwan Dollars</option>
                  <option value="THB">Thailand Baht</option>
                  <option value="TTD">Trinidad and Tobago Dollars</option>
                  <option value="TRL">Turkey Lira</option>
                  <option value="VEB">Venezuela Bolivar</option>
                  <option value="ZMK">Zambia Kwacha</option>
                </select>
            </div>-->
      </div> 
    </div>
  </div>

<br>
</footer>

</div>

</template>

<script>

  export default {
    components: {},
    data() {
       return {
         settings: {
           market: "NO",
           locale: "nb-NO",
           currency: "NOK"
         },
       }
    },
    methods: {
        logout: function() {
        this.$store.dispatch("logout").then(() => {
          this.$router.push("/");
        })
      },
      changeLanguageNO() {
        this.$i18n.locale = 'no'
      },
      changeLanguageEN() {
        this.$i18n.locale = 'en'
      },
      changeLanguageFR() {
        this.$i18n.locale = 'fr'
      },
      changeLanguageIS() {
        this.$i18n.locale = 'is'
      },
      changeLanguageCN() {
        this.$i18n.locale = 'cn'
      },
      changeLanguagePL() {
        this.$i18n.locale = 'pl'
      },
      changeLanguageJP() {
        this.$i18n.locale = 'jp'
     }
    },
    computed: {
      isLoggedIn: function() {
        return this.$store.getters.isLoggedIn;
    }
  }
  }
</script>

<style lang="css" scoped>

/* Navbar styles  */

/* Background */

.background-white {
  background-color: white;
}

.background-offwhite  {
  background-color: #FAFAFA;
}

.pt-md-5, .py-md-5 {
    padding-top: 2rem!important;
    margin-bottom: 0rem !important;
}

.mb-md-5, .my-md-5 {
  margin-bottom: 0rem !important;
}

</style>